var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, CustomElement, Event, html, Prop, styleMap, State } from '@sick-davinci/ce-decorators';
import { style } from './TimeNavigator.style';
/**
 * start: Start time in mSec-UNIX
 * duration: length of time intervall in milliseconds
 */

/**
 * Timeformat with conversion factor from milliseconds to this timeformat
 */
var TimeFormat;

(function (TimeFormat) {
  TimeFormat[TimeFormat["Unknown"] = 0] = "Unknown";
  TimeFormat[TimeFormat["Seconds"] = 1000] = "Seconds";
  TimeFormat[TimeFormat["TenSeconds"] = 10000] = "TenSeconds";
  TimeFormat[TimeFormat["HalfMinute"] = 30000] = "HalfMinute";
  TimeFormat[TimeFormat["Minutes"] = 60000] = "Minutes";
  TimeFormat[TimeFormat["TwoMinutes"] = 120000] = "TwoMinutes";
  TimeFormat[TimeFormat["TenMinutes"] = 600000] = "TenMinutes";
  TimeFormat[TimeFormat["HalfHour"] = 1800000] = "HalfHour";
  TimeFormat[TimeFormat["Hours"] = 3600000] = "Hours";
  TimeFormat[TimeFormat["TwoHours"] = 7200000] = "TwoHours";
  TimeFormat[TimeFormat["SixHours"] = 21600000] = "SixHours";
  TimeFormat[TimeFormat["HalfDay"] = 43200000] = "HalfDay";
  TimeFormat[TimeFormat["Days"] = 86400000] = "Days";
  TimeFormat[TimeFormat["TwoDays"] = 172800000] = "TwoDays";
  TimeFormat[TimeFormat["Weeks"] = 604800000] = "Weeks";
  TimeFormat[TimeFormat["Months"] = 2592000000] = "Months";
  TimeFormat[TimeFormat["HalfYear"] = 15552000000] = "HalfYear";
  TimeFormat[TimeFormat["Years"] = 31104000000] = "Years";
  TimeFormat[TimeFormat["TenYears"] = 311040000000] = "TenYears";
})(TimeFormat || (TimeFormat = {}));

const pressEventType = 'pointerdown';
const moveEventType = 'pointermove';
const releaseEventType = 'pointerup';
const cancelEventType = 'pointercancel';
/**
 * A `davinci-time-navigator` can be used to select a time span between a specific range
 *
 * @example
 * ```
 *     <davinci-time-navigator time-range="[1398500000000, 1498500000000]" time-range-selector="[1408500000000, 1458500000000]" locale="de"></davinci-time-navigator>
 *     <script>
 *       const timenavigator = document.getElementsByTagName('davinci-time-navigator')[0];
 *       timenavigator.addEventListener('change', onTimespanChange);
 *       timenavigator.addEventListener('input', onMove);
 *
 *       function onTimespanChange(event) {
 *           console.log('Timespan changed: ');
 *           console.log(event.detail);
 *       }
 *       function onMove(event) {
 *           console.log('Input change: ');
 *           console.log(event.detail);
 *       }
 *   </script>
 * ```
 */

export let TimeNavigator = (_dec = Component({
  tag: 'davinci-time-navigator',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Event(), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Event(), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Object), _dec12 = State(), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class TimeNavigator extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "locale", _descriptor, this);

    _initializerDefineProperty(this, "change", _descriptor2, this);

    _initializerDefineProperty(this, "input", _descriptor3, this);

    _defineProperty(this, "_requestAnimationFrame", null);

    _defineProperty(this, "_offsetMove", 0);

    _defineProperty(this, "_timeout", null);

    _defineProperty(this, "_mouseUpEvnt", false);

    _initializerDefineProperty(this, "relativeValues", _descriptor4, this);

    _defineProperty(this, "onMouseDownScrollbarEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      const element = event.currentTarget;
      const id = element.id;

      if (!!id) {
        document.addEventListener(releaseEventType, this.onMouseUpScrollbar); // Check if scrollbar arrow was clicked short (one big tick size) or a longer time (as long as it is clicked, the selector is moved continuously with smaller tick size)

        this._timeout = window.setTimeout(() => {
          document.removeEventListener(releaseEventType, this.onMouseUpScrollbar);

          if (!this._mouseUpEvnt) {
            document.addEventListener(releaseEventType, this.onReleaseEvent);
            document.addEventListener(cancelEventType, this.onReleaseEvent);
            this.moveSelectorContinuously(id);
          } else {
            this._moveWholeSelector(id, 40, true);
          }

          this._mouseUpEvnt = false;
          window.clearTimeout(this._timeout);
          this._timeout = null;
        }, 300);
      }
    });

    _defineProperty(this, "onMouseUpScrollbar", event => {
      event.preventDefault();
      event.stopPropagation();
      this._mouseUpEvnt = true;
      document.removeEventListener(releaseEventType, this.onMouseUpScrollbar);
    });

    _defineProperty(this, "moveSelectorContinuously", id => {
      this._moveWholeSelector(id, 1, false);

      this.input.emit(this._selectorTimespan);
      this._requestAnimationFrame = requestAnimationFrame(() => {
        this.moveSelectorContinuously(id);
      });
    });

    _defineProperty(this, "onMouseDownEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      const element = event.target;
      let id = element.parentElement.id;

      if (!id && element.parentElement.classList.contains('inner-select')) {
        element.parentElement.parentElement.classList.add('pressed');
        id = element.parentElement.parentElement.id;
      } else {
        element.parentElement.classList.add('pressed');
      }

      const {
        left
      } = this.shadowRoot.getElementById(id).getBoundingClientRect();
      this._offsetMove = this._getPositionXOf(event) - left;
      document.addEventListener(moveEventType, this.onMouseMoveEvent);
      document.addEventListener(releaseEventType, this.onReleaseEvent);
      document.addEventListener(cancelEventType, this.onReleaseEvent);
    });

    _defineProperty(this, "onMouseMoveEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      const selectorElement = this.shadowRoot.querySelector('.pressed');
      const id = selectorElement === null || selectorElement === void 0 ? void 0 : selectorElement.id;

      if (!!id) {
        if (!this._requestAnimationFrame) {
          // debounce events for a smoother experience
          this._requestAnimationFrame = window.requestAnimationFrame(() => {
            const positionX = this._getPositionXOf(event);

            const {
              left
            } = this.shadowRoot.querySelector('.svg-container').getBoundingClientRect();
            const normalized = positionX - left - this._offsetMove;

            this._updateTimespanFromSelector(normalized, id, false);

            this.input.emit(this._selectorTimespan);
            this._requestAnimationFrame = null;
          });
        }
      }
    });

    _defineProperty(this, "onReleaseEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      const selectorElement = this.shadowRoot.querySelector('.pressed');
      let id = 'selector-mid';
      let positionX;

      if (!!selectorElement) {
        id = selectorElement.id;
        selectorElement.classList.remove('pressed');
        positionX = this._getPositionXOf(event);
      } else {
        positionX = this.shadowRoot.querySelector('#selector-mid').getBoundingClientRect().left;
      }

      const {
        left
      } = this.shadowRoot.querySelector('.svg-container').getBoundingClientRect();
      const normalized = positionX - left - this._offsetMove;

      this._updateTimespanFromSelector(normalized, id, true);

      this._offsetMove = 0;

      if (this._requestAnimationFrame) {
        window.cancelAnimationFrame(this._requestAnimationFrame);
        this._requestAnimationFrame = null;
      }

      document.removeEventListener(moveEventType, this.onMouseMoveEvent);
      document.removeEventListener(releaseEventType, this.onReleaseEvent);
      document.removeEventListener(cancelEventType, this.onReleaseEvent);
    });
  }

  /**
   * The time range to be used to set the timespan of the element.
   * Array of size 2. The first element denotes the start time and the second element denotes the end time of the timespan range;
   * The time has to be in UNIX milliseconds
   * Pass 'undefined' to let the value range be computed automatically (auto-range)
   *
   * @default undefined
   */
  get timeRange() {
    return this._timeRange;
  }

  set timeRange(value) {
    if (value !== undefined && value.length !== 2) {
      throw new Error('array must contain two elements but has ' + value.length + ' elements');
    }

    if (value[0] >= value[1]) {
      // swap values
      const temp = value[0];
      value[0] = value[1];
      value[1] = temp;
    } // Recalculate end date of time range, so the time range of the scale element is consistent


    const timeFormat = this._getTimeFormatFromTimespanDuration(value[1] - value[0]);

    const endDate = this._computeEndDateFromFormat(timeFormat, value[0], value[1]);

    value[1] = endDate.getTime();
    this._timeRange = [...value];

    this._computeValidSelectorTimeRange();

    this._computeTimeSpans();

    this._updateSelectorPositions();
  }
  /**
   * The time range to be used to set the selector of the element.
   * Array of size 2. The first element denotes the start time and the second element denotes the end time of the selector range;
   * The time has to be in UNIX milliseconds
   * Pass 'undefined' to let the value range be computed automatically (auto-range)
   *
   * @default undefined
   */


  get timeRangeSelector() {
    return this._timeRangeSelector;
  }

  set timeRangeSelector(value) {
    if (value !== undefined && value.length !== 2) {
      throw new Error('array must contain two elements but has ' + value.length + ' elements');
    }

    if (value[0] > value[1]) {
      // swap values
      const temp = value[0];
      value[0] = value[1];
      value[1] = temp;
    }

    this._timeRangeSelector = [...value];

    this._computeValidSelectorTimeRange();

    this._computeTimeSpans();

    this._updateSelectorPositions();
  }
  /**
   * Relative values of the selector positions in percentage
   */


  /**
   * See base class
   */
  componentFirstRender() {
    const selectorLeft = this.shadowRoot.getElementById('selector-left');
    selectorLeft.addEventListener(pressEventType, this.onMouseDownEvent);
    const selectorRight = this.shadowRoot.getElementById('selector-right');
    selectorRight.addEventListener(pressEventType, this.onMouseDownEvent);
    const selectorMid = this.shadowRoot.getElementById('selector-mid');
    selectorMid.addEventListener(pressEventType, this.onMouseDownEvent);
    const leftScrollbar = this.shadowRoot.getElementById('scrollbar-left');
    leftScrollbar.addEventListener(pressEventType, this.onMouseDownScrollbarEvent);
    const rightScrollbar = this.shadowRoot.getElementById('scrollbar-right');
    rightScrollbar.addEventListener(pressEventType, this.onMouseDownScrollbarEvent);

    this._updateSelectorPositions();
  }
  /**
   * See base class
   */


  componentDisconnected() {
    const selectorLeft = this.shadowRoot.getElementById('selector-left');
    selectorLeft.removeEventListener(pressEventType, this.onMouseDownEvent);
    const selectorRight = this.shadowRoot.getElementById('selector-right');
    selectorRight.removeEventListener(pressEventType, this.onMouseDownEvent);
    const selectorMid = this.shadowRoot.getElementById('selector-mid');
    selectorMid.removeEventListener(pressEventType, this.onMouseDownEvent);
    const leftScrollbar = this.shadowRoot.getElementById('scrollbar-left');
    leftScrollbar.removeEventListener(pressEventType, this.onMouseDownScrollbarEvent);
    const rightScrollbar = this.shadowRoot.getElementById('scrollbar-right');
    rightScrollbar.removeEventListener(pressEventType, this.onMouseDownScrollbarEvent);

    if (this._requestAnimationFrame) {
      window.cancelAnimationFrame(this._requestAnimationFrame);
      this._requestAnimationFrame = null;
    }

    if (this._timeout) {
      window.clearTimeout(this._timeout);
      this._timeout = null;
    }
  }
  /**
   * Event, if scrollbar arrows are hold down
   *
   * @param event - mouse down event
   */


  /**
   * See base class
   */
  render() {
    this._computeTimeSpans();

    return html`
      <div class="wrapper">
        <div class="container">
          ${this._createTimespanElement()}
          <div class="scrollbar" id="scrollbar-left">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 0L24 24L0 12 z"/><path d="M0 24V0h24V24H0z"  fill="none"/></svg>
          </div>
          <div class="middle">
          </div>
          <div class="scrollbar" id="scrollbar-right">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0L0 24 L24 12 z"/><path d="M0 24V0h24V24H0z"  fill="none"/></svg>
          </div>
        </div>
        <div class="svg-container">
          <svg class="selectors" id="selector-left" viewBox="0 0 20 36" style="${styleMap({
      left: `calc(${this.relativeValues[0]}% - 1.25rem)`
    })}" @>
            <rect rx="2" x="0" y="0" width="100%" height="100%" stroke-width="1" />
            <path d="M 8.5,12 v 12 M 11.5,12 v 12" stroke-width="1" stroke-linecap="round" shape-rendering="crispEdges"></path>
          </svg>
          <svg id="selector-mid" style="${styleMap({
      width: `calc(${this.relativeValues[1] - this.relativeValues[0]}%)`,
      left: `calc(${this.relativeValues[0]}%)`
    })}">
            <svg class="inner-select" preserveAspectRatio="none" viewBox="0 0 846 70" >
              <rect rx="2" x="0" y="50" width="100%" height=20 stroke-width="1" />
              <rect class="overlay" rx="2" x="0" y="0" width="100%" height=50 opacity="50%" stroke-width="1" />
            </svg>
            <svg class="inner-select" viewBox="0 0 10 70" x="0" y="0" height="100%" ">
              <path d="M 2,55 v 10 M 5,55 v 10 M 8,55 v 10" stroke-width="1" stroke-linecap="round" shape-rendering="crispEdges"></path>
            </svg>
          </svg>
          <svg class="selectors" id="selector-right" viewBox="0 0 20 36" style="${styleMap({
      left: `calc(${this.relativeValues[1]}%)`
    })}">
            <rect rx="2" x="0" y="0" width="100%" height="100%" stroke-width="1" />
            <path d="M 8.5,12 v 12 M 11.5,12 v 12" stroke-width="1" stroke-linecap="round" shape-rendering="crispEdges"></path>
          </svg>
        </div>
      </div>
      `;
  }
  /**
   * Compute valid time ranges
   */


  _computeValidSelectorTimeRange() {
    if (this._timeRange == undefined) {
      this._timeRange = [0, Date.now()];
    }

    if (this.timeRangeSelector == undefined) {
      this._timeRangeSelector = [...this.timeRange];
    } else {
      if (this._timeRangeSelector[0] < this._timeRange[0] || this._timeRangeSelector[0] > this._timeRange[1]) {
        this._timeRangeSelector[0] = this._timeRange[0];
      }

      if (this._timeRangeSelector[1] > this._timeRange[1] || this._timeRangeSelector[1] < this._timeRange[0]) {
        this._timeRangeSelector[1] = this._timeRange[1];
      }
    }
  }
  /**
   * Compute time spans
   */


  _computeTimeSpans() {
    if (this._timeRange == undefined) {
      this._timeRange = [0, Date.now()];
    }

    this._timespan = {
      start: this._timeRange[0],
      duration: this._timeRange[1] - this._timeRange[0]
    };

    if (this.timeRangeSelector == undefined) {
      this._timeRangeSelector = [...this.timeRange];
    }

    this._selectorTimespan = {
      start: this._timeRangeSelector[0],
      duration: this._timeRangeSelector[1] - this._timeRangeSelector[0]
    };
  }
  /**
   * Update the timespan for the selector
   *
   * @param start - start time in UNIX milliseconds
   * @param end - end time in UNIX milliseconds
   * @param emit - Flag, indicating if timespan change event should be emitted
   */


  _updateSelectorTimespan(start, end, emit) {
    this._selectorTimespan = {
      start: start,
      duration: end - start
    };
    this._timeRangeSelector = [start, end];

    if (emit) {
      this.change.emit(this._selectorTimespan);
    }
  }
  /**
   * Returns the time format for a specific timespan duration
   *
   * @param duration - duration of time span in ms
   */


  _getTimeFormatFromTimespanDuration(duration) {
    if (duration <= 8000) {
      return TimeFormat.Seconds;
    } // 10sec
    else if (duration > 8000 && duration <= 80000) {
      return TimeFormat.TenSeconds;
    } // 30sec
    else if (duration > 80000 && duration <= 240000) {
      return TimeFormat.HalfMinute;
    } // 1min
    else if (duration > 240000 && duration <= 480000) {
      return TimeFormat.Minutes;
    } // 2min
    else if (duration > 480000 && duration <= 1000000) {
      return TimeFormat.TwoMinutes;
    } // 10min
    else if (duration > 1000000 && duration <= 4800000) {
      return TimeFormat.TenMinutes;
    } // 30min
    else if (duration > 4800000 && duration <= 14400000) {
      return TimeFormat.HalfHour; // 1 hour
    } else if (duration > 14400000 && duration <= 30000000) {
      return TimeFormat.Hours; // 2 hour
    } else if (duration > 30000000 && duration <= 57000000) {
      return TimeFormat.TwoHours; // 6 hours
    } else if (duration > 57000000 && duration <= 172000000) {
      return TimeFormat.SixHours; // 12 hours
    } else if (duration > 172000000 && duration <= 345000000) {
      return TimeFormat.HalfDay; // Days
    } else if (duration > 345000000 && duration <= 691000000) {
      return TimeFormat.Days; // two days
    } else if (duration > 691000000 && duration <= 1380000000) {
      return TimeFormat.TwoDays; // weeks
    } else if (duration > 1380000000 && duration <= 4200000000) {
      return TimeFormat.Weeks; // show time in Months
    } else if (duration > 4200000000 && duration <= 18000000000) {
      return TimeFormat.Months; // show time in 6 months
    } else if (duration > 18000000000 && duration <= 100000000000) {
      return TimeFormat.HalfYear; // show time in years
    } else if (duration > 100000000000 && duration <= 225000000000) {
      return TimeFormat.Years; // show time in ten years
    } else if (duration > 225000000000) {
      return TimeFormat.TenYears;
    } else {
      return TimeFormat.Unknown;
    }
  }
  /**
   *Creates the timespan element according to the given start and end time
   */


  _createTimespanElement() {
    const timeFormat = this._getTimeFormatFromTimespanDuration(this._timespan.duration);

    const numberOf = Math.ceil(this._timespan.duration / timeFormat);
    const div = document.createElement('div');
    div.id = 'scale';

    for (let i = 0; i < numberOf; i++) {
      const timeformatElement = document.createElement('div');
      timeformatElement.className = 'scale-element';
      const label = document.createElement('label');
      let date;

      if (timeFormat == TimeFormat.Months) {
        date = new Date(this._timespan.start);
        date.setMonth(date.getMonth() + i);
      } else if (timeFormat == TimeFormat.HalfYear) {
        date = new Date(this._timespan.start);
        date.setMonth(date.getMonth() + i * 6);
      } else if (timeFormat == TimeFormat.Years) {
        date = new Date(this._timespan.start);
        date.setFullYear(date.getFullYear() + i);
      } else if (timeFormat == TimeFormat.TenYears) {
        date = new Date(this._timespan.start);
        date.setFullYear(date.getFullYear() + i * 10);
      } else {
        date = new Date(this._timespan.start + i * timeFormat);
      }

      label.textContent = this._getTimeStringByTimeformat(timeFormat, date, i == 0);
      label.className = 'date-label';
      timeformatElement.appendChild(label);
      div.appendChild(timeformatElement);
    }

    return html`${div}`;
  }
  /**
   * Returns date or time string for a date by timeformat
   *
   * @param timeFormat - the time format (eg. days, ...)
   * @param date - the date
   * @param showAll - Flag, indicating if a whole locale string should be used
   */


  _getTimeStringByTimeformat(timeFormat, date, showAll) {
    // Use english as default locale, if invalid locale was entered
    if (showAll) {
      try {
        return date.toLocaleString(this.locale);
      } catch (err) {
        return date.toLocaleString('en');
      }
    }

    if (timeFormat <= TimeFormat.Minutes) {
      try {
        return date.toLocaleTimeString(this.locale);
      } catch (err) {
        return date.toLocaleTimeString('en');
      }
    } else if (timeFormat >= TimeFormat.Days) {
      try {
        return date.toLocaleDateString(this.locale);
      } catch (err) {
        return date.toLocaleDateString('en');
      }
    } else {
      try {
        return date.toLocaleString(this.locale);
      } catch (err) {
        return date.toLocaleString('en');
      }
    }
  }
  /**
   * Returns the recalculated end date for a specific time format type
   *
   * @param timeFormat - the specific time format (days, months, ...)
   * @param startDateInMs - start date in unix ms
   * @param endDateInMs - end date in unix ms
   */


  _computeEndDateFromFormat(timeFormat, startDateInMs, endDateInMs) {
    let endDate;
    const numberOfTimeformat = Math.ceil((endDateInMs - startDateInMs) / timeFormat);

    if (timeFormat == TimeFormat.Months) {
      endDate = new Date(startDateInMs);
      endDate.setMonth(endDate.getMonth() + numberOfTimeformat);
    } else if (timeFormat == TimeFormat.HalfYear) {
      endDate = new Date(startDateInMs);
      endDate.setMonth(endDate.getMonth() + numberOfTimeformat * 6);
    } else if (timeFormat == TimeFormat.Years) {
      endDate = new Date(startDateInMs);
      endDate.setFullYear(endDate.getFullYear() + numberOfTimeformat);
    } else if (timeFormat == TimeFormat.TenYears) {
      endDate = new Date(startDateInMs);
      endDate.setFullYear(endDate.getFullYear() + numberOfTimeformat * 10);
    } else {
      endDate = new Date(startDateInMs + numberOfTimeformat * timeFormat);
    }

    return endDate;
  }
  /**
   * Updates the selector positions
   */


  _updateSelectorPositions() {
    const relationLeft = (this._timeRangeSelector[0] - this._timeRange[0]) / this._timespan.duration * 100;
    const relationRight = (this._timeRangeSelector[1] - this._timeRange[0]) / this._timespan.duration * 100;
    this.relativeValues = [relationLeft, relationRight];
  }
  /**
   * Get the x position of mouse / touch
   *
   * @param event - mouse or touch event
   * @returns the x position
   */


  _getPositionXOf(event) {
    let positionX = event.clientX;

    if (positionX === undefined) {
      positionX = event.changedTouches[0].clientX;
    }

    return positionX;
  }
  /**
   * Validates a number value to a valid number
   *
   * @param value - the number value to validate
   * @param min - the min value
   * @param max - the max value
   */


  _validateValue(value, min, max) {
    if (isNaN(value)) {
      value = 0;
    }

    if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }

    return value;
  }
  /**
   * Move whole selector with specific tick size
   *
   * @param id - id of the scrollbar part (scrollbar-left or scrollbar-right)
   * @param tickSize - size of the ticks to move the selector
   * @param emit - flag, indicating if change event should be emitted
   */


  _moveWholeSelector(id, tickSize, emit) {
    const {
      left
    } = this.shadowRoot.querySelector('#selector-mid').getBoundingClientRect();
    const {
      left: offsetContainer
    } = this.shadowRoot.querySelector('.svg-container').getBoundingClientRect();

    if (id === 'scrollbar-left') {
      this._updateTimespanFromSelector(left - offsetContainer - tickSize, 'selector-mid', emit);
    } else {
      this._updateTimespanFromSelector(left - offsetContainer + tickSize, 'selector-mid', emit);
    }
  }
  /**
   * Update timespan according to the selector positions
   *
   * @param value - new value of selector
   * @param id - the id of the selector element
   * @param emit - Flag, indicating if change event should be emitted
   */


  _updateTimespanFromSelector(value, id, emit) {
    const {
      width
    } = this.shadowRoot.querySelector('.svg-container').getBoundingClientRect();
    const percentage = value / width * 100;
    const currentDuration = percentage / 100 * this._timespan.duration;
    const newValue = this._timespan.start + Math.round(currentDuration);

    if (id == 'selector-left') {
      const newStart = this._validateValue(newValue, this._timeRange[0], this._timeRangeSelector[1]);

      this._updateSelectorTimespan(newStart, this._timeRangeSelector[1], emit);
    } else if (id == 'selector-right') {
      const newEnd = this._validateValue(newValue, this._timeRangeSelector[0], this._timeRange[1]);

      this._updateSelectorTimespan(this._timeRangeSelector[0], newEnd, emit);
    } else if (id == 'selector-mid') {
      const newStart = this._validateValue(newValue, this._timeRange[0], this._timeRange[1] - this._selectorTimespan.duration);

      const newEnd = newStart + this._selectorTimespan.duration;

      this._updateSelectorTimespan(newStart, newEnd, emit);
    }

    this._updateSelectorPositions();
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "locale", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'en';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "timeRange", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "timeRange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timeRangeSelector", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "timeRangeSelector"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "relativeValues", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0, 100];
  }
})), _class2)) || _class);
